module.exports = __webpack_public_path__ + "static/img/HELLO300_300.9f472aa5.png";